import script from "./AdminReviewMaterialRequestDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminReviewMaterialRequestDialog.vue?vue&type=script&setup=true&lang=js"

import "./AdminReviewMaterialRequestDialog.vue?vue&type=style&index=0&id=0b8bf694&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b8bf694"]])

export default __exports__